import React, { useState } from 'react';
import { get, filter, head } from 'lodash';
import { Divider } from 'antd';
import { array, object, func } from 'prop-types';
import { FormSelect, Icon, ConfirmFooterButtons, FlexContainer, Row, Column } from '../../common';
import { UPDATE_COMERCIAL_POLICY_REFERENCE } from '../../../queries';

const ComercialPolicyReferenceCard = ({
    salesChannelOptions,
    comercialPolicyReference,
    handleRemoveComercialPolicy,
    client,
    refetchQuery
}) => {
    const [isUpdating, setIsUpdating] = useState(false);
    const [loading, setLoading] = useState(false);
    const isReferenceSelf = get(comercialPolicyReference, 'comercial_policy') === get(comercialPolicyReference, 'comercial_policy_reference');
    const [comercialPolicyOut, setComercialPolicyOut] = useState({
        label: get(head(filter(salesChannelOptions, ({ value }) => value === get(comercialPolicyReference, 'comercial_policy_reference'))), 'label'),
        value: get(comercialPolicyReference, 'comercial_policy_reference')
    });

    const handleButtonUpdate = async () => {
        setLoading(true);
        await client.mutate({
            mutation: UPDATE_COMERCIAL_POLICY_REFERENCE,
            variables: {
                comercial_policy: get(comercialPolicyReference, 'comercial_policy'),
                comercial_policy_out: get(comercialPolicyOut, 'value')
            }
        });
        setLoading(false);
        setIsUpdating(false);
        refetchQuery();
    };

    return (<FlexContainer
        position='relative'
        direction='column'
        backgroundColor='white'
        borderRadius={3}
        minWidth={'18%'}
        flex='1 0 300px'
        padding={24}
        style={{
            boxShadow: 'rgb(0 0 0 / 20%) 3px 0px 0px -4px, rgb(0 0 0 / 6%) 0px 1px 0px 0px, rgb(0 0 0 / 6%) 1px 0px 0px 0px'
        }}
    >
        {`${get(comercialPolicyReference, 'id')} - ${get(comercialPolicyReference, 'title')}`}
        <FormSelect
            disabled={!isUpdating}
            label='Tienda'
            value={isReferenceSelf ? {
                label: get(comercialPolicyReference, 'title'),
                value: get(comercialPolicyReference, 'comercial_policy')
            } : comercialPolicyOut}
            placeholder='Codigo de ubicación'
            options={filter(salesChannelOptions, ({ id }) => id === get(comercialPolicyReference, 'id'))}
            onChange={({ value }) => setComercialPolicyOut(value)}
        />
        {isUpdating
            ? <ConfirmFooterButtons
                loading={loading}
                justify='center'
                onCancel={() => setIsUpdating(false)}
                onConfirm={() => handleButtonUpdate()}
            />
            : <Row mT={20} justify='space-evenly'>
                <Icon name='restart' color='#1FA02E' size={20} onClick={() => handleRemoveComercialPolicy(comercialPolicyReference)} />
                <Divider type='vertical' style={{ fontSize: 20 }} />
                <Icon name='edit' color='#1FA02E' size={20} onClick={() => setIsUpdating(true)} />
            </Row>
        }
    </FlexContainer>);
};

ComercialPolicyReferenceCard.propTypes = {
    salesChannelOptions: array,
    comercialPolicyReference: object,
    handleRemoveComercialPolicy: func,
    client: object,
    refetchQuery: func
};

export default ComercialPolicyReferenceCard;
